import React, { PropTypes } from 'react';
import LatLngInput from '../Common/LatLngInput';
import { validateLat, validateLng } from '../../businessLogic/util';
import ReactTooltip from 'react-tooltip';

export default class Rect extends React.Component {	

	render () {	
		const { removeRect, index, rect, setLatNw, setLngNw, setLatSe, setLngSe } = this.props;		
		return (			
			<div className="custom-local-box">

				<div className="fechar-btn" >
					<span>
						<i className="fa fa-times pointer" data-tip="Remover retângulo" onClick={() => {
							if ( typeof this.rectangle !== "undefined" ) this.rectangle.setMap(null);
							removeRect(index);
						}} />
					</span>
					<ReactTooltip />
				</div>

				<div className="latlong">				
					<div className="lat">
						<LatLngInput
							label="Latitude N"
							value={rect.nw.lat}
							index={index}
							validation={validateLat}
							action={setLatNw}
							helpText="Entre -90 e 90" 
						/>		
					</div>
					<div className="long">
						<LatLngInput
							label="Longitude W"
							value={rect.nw.lng}
							index={index}
							validation={validateLng}
							action={setLngNw}
							helpText="Entre -180 e 180" 
						/>
					</div>
				</div>
				<div className="latlong">				
					<div className="lat">
						<LatLngInput
							label="Latitude S"
							value={rect.se.lat}
							index={index}
							validation={validateLat}
							action={setLatSe}
							helpText="Entre -90 e 90" 
						/>
					</div>
					<div className="long">
						<LatLngInput
							label="Longitude E"
							value={rect.se.lng}
							index={index}
							validation={validateLng}
							action={setLngSe}
							helpText="Entre -180 e 180" 
						/>
					</div>				
				</div>
			</div>
		);
	}
}

Rect.propTypes = {
	rect: PropTypes.object.isRequired,
	index: PropTypes.number.isRequired,
	removeRect: PropTypes.func.isRequired,
	setLatNw: PropTypes.func.isRequired,
	setLngNw: PropTypes.func.isRequired,
	setLatSe: PropTypes.func.isRequired,
	setLngSe: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Documents/Rect.js